import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DesktopNavigatorVerticalFragment } from '../../../generated/types';
import { tc } from '../../../lib/trackingContext';
import { useEnableClubModa } from '../../../hooks/useEnableClubModa';
import { Link } from '../../Link';
import { useDesktopNavigationContext } from '../DesktopNavigationProvider';

import './DesktopNavigationVertical.scss';

type Props = {
  vertical: DesktopNavigatorVerticalFragment;
};

export const DesktopNavigationVertical: React.FC<Props> = ({ vertical }) => {
  const enableClubModa = useEnableClubModa();
  const { selectedVerticalId, handleChangeSelectedVertical } = useDesktopNavigationContext();

  const isSelected = selectedVerticalId === vertical.id;

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (isSelected) return;

      if (!handleChangeSelectedVertical?.(vertical.id)) return;

      tc.track('Navigation Item Clicked', {
        addToTrackingEvent: {
          url: vertical.href,
          text: vertical.title,
          label: vertical.title,
          hierarchy: vertical.title,
          coordinateX: event?.pageX || 0,
          coordinateY: event?.pageY || 0
        }
      });
    },
    [handleChangeSelectedVertical, isSelected, vertical.href, vertical.id, vertical.title]
  );

  return (
    <Link
      className={classNames('DesktopNavigationVertical', {
        'DesktopNavigationVertical--club': enableClubModa,
        'DesktopNavigationVertical--selected': isSelected,
        'DesktopNavigationVertical--unselected': !isSelected
      })}
      data-testid="DesktopNavigationVertical"
      to={vertical.href}
      onClick={handleClick}
    >
      <div
        className={classNames('DesktopNavigationVertical__title', {
          'DesktopNavigationVertical__title--club': enableClubModa,
          'DesktopNavigationVertical__title--selected': isSelected
        })}
        data-testid="DesktopNavigationVertical__title"
      >
        {vertical.title}
      </div>
    </Link>
  );
};
